// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header-Aw1ae";
var _3 = "close-Eob0K";
var _4 = "rules-3r3tr";
export { _1 as "__esModule", _2 as "header", _3 as "close", _4 as "rules" }
export default { "__esModule": _1, "header": _2, "close": _3, "rules": _4 }
